import { render, staticRenderFns } from "./AuthForm.vue?vue&type=template&id=456ddf6a&scoped=true&lang=pug"
import script from "./AuthForm.vue?vue&type=script&lang=ts"
export * from "./AuthForm.vue?vue&type=script&lang=ts"
import style0 from "./AuthForm.vue?vue&type=style&index=0&id=456ddf6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456ddf6a",
  null
  
)

export default component.exports